/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import ChildIssuesIcon from '@atlaskit/icon/glyph/child-issues';
var rotateSvg = css({
  transform: 'rotate(180deg)',
  display: 'inline-block'
});

/**
 * ChildIssuesIcon but 180 degrees rotated
 */
var RelatedLinksActionIcon = function RelatedLinksActionIcon() {
  return jsx("span", {
    css: rotateSvg
  }, jsx(ChildIssuesIcon, {
    label: "View recent links..."
  }));
};
export default RelatedLinksActionIcon;